import React from "react";
import _ from "lodash";

import AllSelectBtn from "./AllSelectBtn";

// options = > { key: {text, count} } object format asure key is unique
// allKey = > key for all button
function OptionSelector({
  options,
  selected,
  handleSelectChanged,
  allKey = "",
  standaloneSelectAll = false,
}) {
  const list = _.filter(_.keys(options), (key) => key !== allKey);
  return (
    <div className="flex flex-wrap gap-x-2 gap-y-1">
      {options[allKey] && (
        <div className={standaloneSelectAll ? "w-full" : ""}>
          <AllSelectBtn
            value={selected}
            buttonText={`${options[allKey].text || allKey} ${
              options[allKey].count !== undefined
                ? `(${options[allKey].count})`
                : ""
            }`}
            handleClick={() => handleSelectChanged(allKey)}
          ></AllSelectBtn>
        </div>
      )}
      {list.map((key) => {
        return (
          <button
            key={key}
            type="button"
            className={`rounded px-2 py-1 font-semibold ${
              selected === key
                ? "bg-indigo-200 text-indigo-900"
                : "text-gray-700 hover:bg-gray-200 hover:text-indigo-800"
            }`}
            onClick={() => handleSelectChanged(key)}
          >
            {options[key].text || key}
            {options[key].count !== undefined ? ` (${options[key].count})` : ""}
          </button>
        );
      })}
    </div>
  );
}

export default OptionSelector;
